import { useDisable } from "../../../hooks/use-disable";
import { useFormContext } from "react-hook-form";
import DocumentDropzoneUI from "../../UI/DocumentDropzoneUI";

const ContactAttachment = () => {
  const { control, setValue } = useFormContext();
  const [disabled] = useDisable();
  return (
    <DocumentDropzoneUI
      control={control}
      name="attachment_list"
      setValue={setValue}
      disabled={disabled}
      maxSize={5}
      multiple
    />
  );
};

export default ContactAttachment;
